import React from 'react'
import { useTranslation } from 'react-i18next'
import imgRope from '../assets/images/imgrope.jpg'
import { HashLink as Link } from 'react-router-hash-link';
import Button from '../components/Button'

function Page404() {
  const { t } = useTranslation();
  return (
    <div style={{backgroundImage: `url(${imgRope})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '100vh'}} className='flex items-center'>
      <div className='m-auto text-white text-center text-2xl leading-loose'>
        <h1 className='text-6xl text-center mb-10'>{t('page404.title')}</h1>
        <p className='text-white'>{t('page404.line1')}</p>
        <p className='mb-10 text-white'>{t('page404.line2')}</p>
        <Link to="/" className="btn btn-primary"><Button text={t('button.homepage')} /></Link>
      </div>
    </div>
  )
}

export default Page404
